import React from "react";
import { TrendingUp, Check } from "lucide-react";

const ROWS = [
  { label: "Salário de entrada", value: "~1.600€/mês", highlight: false },
  { label: "Salário com experiência", value: "2.500€ – 4.000€", highlight: true },
  { label: "Procura no mercado", value: "Alta", icon: Check },
  { label: "Custo do curso", value: "147€", strike: false },
  { label: "Recuperas em", value: "~3 dias de trabalho", highlight: true },
];

export default function ROI() {
  return (
    <section
      className="py-24 sm:py-32 bg-[#0A0A0A] border-b border-white/10"
      data-testid="roi-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
            <TrendingUp className="w-3.5 h-3.5" />
            O Investimento Faz Sentido
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            RECUPERAS <br />
            <span className="text-yellow-400">EM 3 DIAS.</span>
          </h2>
          <p className="mt-6 text-zinc-400 max-w-md leading-relaxed">
            O mercado da construção em Portugal está em falta de manobradores certificados.
            Quem tem o cartão, comanda o próprio salário.
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="border border-white/10 divide-y divide-white/10">
            {ROWS.map((r, i) => (
              <div
                key={r.label}
                data-testid={`roi-row-${i}`}
                className={`flex items-center justify-between p-5 sm:p-6 ${
                  r.highlight ? "bg-yellow-400/5" : "bg-zinc-900/30"
                }`}
              >
                <span className="text-sm sm:text-base text-zinc-300">{r.label}</span>
                <span
                  className={`font-display text-xl sm:text-2xl ${
                    r.highlight ? "text-yellow-400" : "text-white"
                  }`}
                >
                  {r.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
